import * as React from 'react';
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Grid from '@mui/material/Grid';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Box from '@mui/system/Box';
import { makeStyles } from '@mui/styles';
import { Item } from './ProductDetails';
import Price from '../../../../../common/Price';
import CustomRating from '../../../../../common/Rating';
import { SET_SELECTED_PRODUCT } from '../../../../../store/types/actions/ProductAction';
import { useCommonStyles } from '../../../../../common/common';

const useStyles = makeStyles({
  customImageList: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  '.css-186gwnw-MuiImageListItemBar-titleWrap': {
    paddingBottom: '0px'
  }
});

export default function ProductListItems(props: any) {
  const { products } = props;
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const commonClasses = useCommonStyles()

  const getSubTitleContent = (item: any) => {
    const seller = item.seller && item.seller.seller ? item.seller.seller : {}
    return <Box display="flex" flexDirection="column" mt={1}>
        <Box display="flex" component="p" flexDirection="row" justifyContent="space-between">
          <CustomRating rating={item.rating} />
          <Box component="h6" m={0}>{seller.name}</Box>
        </Box>
        <Price price={item.price} discount={item.discount} />
    </Box>
  }

  const handleOnProductItem = (e: any, productId: string) => {
    e.preventDefault()
    dispatch({ type: SET_SELECTED_PRODUCT, paylod: null })
    history.push('/productDetails/' + productId)
  }

  return (
      <ImageList cols={1}>
          <Box>
            <Grid container spacing={0}>
              {products && products.length > 0 && products.map((item: any) => (
                <Grid key={item._id} item xs={12} sm={3} md={3} lg={2} style={{padding: '8px'}}>
                  <Item className={commonClasses.itemCls}>
                    <ImageListItem
                      className={classes.customImageList}
                      onClick={(e) => handleOnProductItem(e, item._id)}
                      >
                      <img
                        src={`${item.image}`}
                        alt={item.name}
                        loading="lazy"
                        style={{ width: '100%', height: '200px'}}
                      />
                      <ImageListItemBar
                        title={<a href="/" style={{textDecoration: 'none'}} onClick={(e)=> handleOnProductItem(e, item._id)}>{item.name}</a>}
                        subtitle={getSubTitleContent(item)}
                        position="below"
                      />
                    </ImageListItem>
                  </Item>
                </Grid>
              ))}
            </Grid>
          </Box>
    </ImageList>
  );
}

